import { defineStore } from "pinia";
import * as choiceApi from "../ChoiceApi"
import { IPatientActionAndKeyModel } from "../Api/PatientAction";

export const usePatientActionStore = defineStore('PatientActionStore', () => {

    async function getPatientActions(reset: boolean = false): Promise<IPatientActionAndKeyModel[] | undefined>
    {
        if (reset)
            patientActions = undefined;

        if (!patientActions)
        {
            patientActions = await choiceApi.patientAction.listPatientActions();
        }
        return patientActions;
    }
    let patientActions: IPatientActionAndKeyModel[] | undefined;

    async function getPatientAction(patientActionKeyGuid: string): Promise<IPatientActionAndKeyModel|undefined>
    {
        return (await getPatientActions())?.find(i => i.patientActionKeyGuid === patientActionKeyGuid);
    }

    return { getPatientActions, getPatientAction };
});


